<template>
    <div :class="{'td-companies-messages-banner': true, 'td-is-visible': messageIsVisible, 'td-is-hidden-company-message': isDashboardIflowRfid}">
        <div v-if="companyMessage !== false">
            <img class="td-company-message-logo" src="../assets/logo-white.png"/>
            <div class="td-company-message-wrap">
                <a href="#" @click.prevent="onClick_closeMessage" class="td-icon-close td-filter-reset"></a>
                <div class="td-company-message-title">{{companyMessage.title}}</div>
                <div class="td-company-message-body" v-html="companyMessage.message"></div>
            </div>
        </div>
    </div>
</template>

<script>
import tdApi from "../tdApi";
import tdLocalStorage from "../tdLocalStorage";

export default {
    data() {
        return {
            companyMessage: false
        }
    },

    mounted() {
        this.getCompanyMessage();
    },

    methods: {
        getCompanyMessage() {
            let vm = this;

            //display only on admin accounts
            if (!vm.$store.getters.isAdmin) {
                return;
            }

            let apiCall = new tdApi('auth/get_company_message');
            apiCall.run({
                'post': {},
                'done': function (apiReply) {
                    vm.companyMessage = apiReply.company_message;
                },
                'error': function (errorMessage) {
                    window.EventBus.$emit('banner_onErrorPermanent', 'Operation failed:', errorMessage);
                }
            });
        },

        onClick_closeMessage() {
            let vm = this;

            window.EventBus.$emit('appLoader_show');

            let messagesClosed = [vm.companyMessage.ID],
                localStorageMessagesClosed = tdLocalStorage.get('td_companies_messages_closed');

            if (localStorageMessagesClosed) {
                messagesClosed = messagesClosed.concat(localStorageMessagesClosed);
            }

            tdLocalStorage.set('td_companies_messages_closed', messagesClosed);

            let apiCall = new tdApi('auth/increase_company_message_read_count');
            apiCall.run({
                'post': {
                    ID: vm.companyMessage.ID
                },
                'done': function (apiReply) {
                    //do nothing
                    window.EventBus.$emit('appLoader_hide');
                    vm.companyMessage = false;
                },
                'error': function (errorMessage) {
                    window.EventBus.$emit('appLoader_hide');
                    window.EventBus.$emit('banner_onErrorPermanent', 'Operation failed:', errorMessage);
                }
            });
        }
    },

    computed: {
        messageIsVisible() {
            let vm = this,
                buffy = false;

            if (vm.companyMessage !== false) {
                let localStorageMessagesClosed = tdLocalStorage.get('td_companies_messages_closed');

                if (!localStorageMessagesClosed || localStorageMessagesClosed.indexOf(vm.companyMessage.ID) === -1) {
                    buffy = true;
                }
            }

            return buffy;
        },
        isDashboardIflowRfid() {
            return this.$route.path.startsWith('/dashboardIflowRfid');
        }
    },

    watch: {
        $route (to, from){
            if (to.name === 'dashboardRoute' || to.name === 'activityEventsRoute') {
                this.getCompanyMessage();
            }
        }
    },
}
</script>

<style lang="scss">
.td-companies-messages-banner {
    visibility: hidden;
    position: fixed;
    bottom: 15px;
    left: 15px;
    padding: 10px 10px 10px 3px;
    width: 350px;
    max-height: 300px;
    height: fit-content;
    border-radius: 4px;
    z-index: 9999;
    overflow-y: auto;
    background-color: #ffffff;
    color: #888;
    -webkit-box-shadow: 0 2px 20px rgba(0,0,0,0.15);
    box-shadow: 0 2px 20px rgba(0,0,0,0.15);
    -moz-box-shadow: 0 2px 20px rgba(0,0,0,0.15);

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.15);
        background-color: #dfdfdf;
    }

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #999;
        opacity: 1;
    }


    &.td-is-visible {
        visibility: visible;
    }

    >div {
        display: flex;
        gap: 8px;
    }

    .fa-times {
        position: absolute;
        right: 5px;
        top: 5px;
        padding: 5px;
    }
    .td-company-message-logo {
        filter: invert(60%) sepia(44%) saturate(2023%) hue-rotate(208deg) brightness(84%) contrast(82%);
        width: 50px;
        height: 50px;
    }
    .td-company-message-wrap {
        position: relative;
        flex: 1 1 auto;
        .td-icon-close {
            float: right;
        }
        .td-company-message-title {
            padding-right: 35px;
            margin-top: 3px;
            font-size: 14px;
            font-weight: 600;
            color: #333;
            word-break: break-word;
            line-height: 1.3;
        }
        .td-company-message-body {
            word-break: break-word;
            padding-top: 5px;
            margin-top: 7px;
            position: relative;
            white-space: pre-wrap;
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 1px;
                width: calc(100% - 30px);
                border-top: 1px solid #eee;
            }
        }
    }

    &.td-is-hidden-company-message {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/companiesMessages.vue